/**
 * The clouds and environments where the SRE (AGRM) API is reachable.
 *
 * This lives outside both the API layer and the hooks that consume it, because it had drifted into
 * copies in each. `AGRMApi` re-exports `isValidCloudOrEnvironment` so its existing callers keep
 * working against the same list.
 */

export const SRE_VALID_CLOUDS = [
    'USNat',
    'USSec',
    'Fairfax',
    'Bleu',
    'Delos',
    'GovSG',
    'Sovmock',
];

export const SRE_VALID_ENVIRONMENTS = ['Development', 'public.dev', 'Test'];

export const isSreHealthAvailable = (
    cloud: string,
    environment: string
): boolean => {
    const lowerCloud = (cloud || '').toLowerCase();
    const lowerEnvironment = (environment || '').toLowerCase();

    return (
        isValidCloudOrEnvironment(cloud, environment) ||
        (lowerCloud === 'public' && lowerEnvironment === 'public.sovmock')
    );
};

/**
 * Legacy availability for the other AGRM operations, including their dev/test exception.
 */
export const isValidCloudOrEnvironment = (
    cloud: string,
    environment: string
): boolean => {
    const lowerCloud = (cloud || '').toLowerCase();
    const lowerEnvironment = (environment || '').toLowerCase();

    const isValidEnvironment = SRE_VALID_ENVIRONMENTS.map((e) =>
        e.toLowerCase()
    ).includes(lowerEnvironment);

    const isValidCloud = SRE_VALID_CLOUDS.map((c) => c.toLowerCase()).includes(
        lowerCloud
    );

    return isValidCloud || isValidEnvironment;
};
